import { createApp } from 'vue'
import FloatingVue from 'floating-vue'
import 'floating-vue/dist/style.css'
import router from './router/router'
import App from './App.vue'

router.beforeEach((to, from, next) => {
  if (to.meta != undefined) {
    if (to.meta.title != undefined) {
      document.title = to.meta.title + " - SUMSG" || "SUMSG";
    }
    if (to.meta.requireAuth && to.meta.requireAuth != undefined) {
      let userinfo = localStorage.getItem("userinfo");
      if (!userinfo) {
        next({
          path: '/signin',
          query: { redirect: to.fullPath }
        })
      }
    }
  }

  next()
})

const app = createApp(App);
app.use(router);
app.use(FloatingVue)
app.mount('#app');